import { BLOCKED_EMAIL_DOMAINS } from "data/blockedemails";
import { z } from "zod";

export const ppmvsSchema = z.object({
	lat: z.string().nonempty("location is required"),
	lng: z.string().nonempty("location is required"),
	lga: z.string().nonempty("LGA is required"),
	town: z.string().nonempty("state, LGA and town is required"),
	state: z.string().nonempty("state is required"),
	phone_number: z
		.string()
		.nonempty("phone number is required")
		.regex(/^0\d{10}$/, {
			message:
				"Invalid phone number. Use digits only, no spaces, starting with 0, and 11 digits in total.",
		}),
	whatsapp_number: z
		.string()
		.nonempty("whatsapp number is required")
		.regex(/^0\d{10}$/, {
			message:
				"Invalid whatsapp number. Use digits only, no spaces, starting with 0, and 11 digits in total.",
		}),
	contact_name: z.string().nonempty("contact name is required"),
	educational_background: z.string().nonempty("education is required"),
	qualification: z.string().nonempty("qualification is required"),
	shop_name: z.string().nonempty("shop name is required"),
	shop_address: z.string().nonempty("shop address is required"),
	email: z
		.string()
		.email("enter a valid email")
		.nonempty("email is required")
		.refine(
			(email) => {
				const domain = email.split("@")[1];
				return !BLOCKED_EMAIL_DOMAINS.includes(domain);
			},
			{ message: "use a valid email" }
		),
	what_type_of_outlet_do_you_operate: z
		.string()
		.nonempty("type of outlet is required"),
	reg_no: z.string().optional(),
	outlet_img_url: z
		.string()
		.nonempty("upload an image of you outside the shop"),
	inlet_img_url: z.string().nonempty("upload an image of you in the shop"),
	cert_img_url: z.string().optional(),
});
